const library = {
  state: () => ({
    editLibraryData: {},
    showLibraryAction: false,
    newassignmentDialog: false,
    isLogged_In: false
  }),

  getters: {
    editLibraryData(state) {
      return state.editLibraryData;
    },
    newassignmentDialog(state) {
      return state.newassignmentDialog;
    },
    showLibraryAction(state) {
      return state.showLibraryAction;
    },
    isLogged_In(state) {
      return state.isLogged_In;
    }
  },

  mutations: {
    saveEditLibrary(state, data) {
      console.log("🚀 ~ saveEditLibrary ~ data:", data);
      state.editLibraryData = data;
    },

    changeLibraryAction(state, data) {
      state.showLibraryAction = data;
    },
    openAssignmentDialog(state) {
      state.newassignmentDialog = true;
    },
    closeAssignmentDialog(state) {
      state.newassignmentDialog = false;
    },
    setLoggedIn(state, value) {
      state.isLogged_In = value;
    }
  }
};

export default library;
